"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxyProvider = exports.getRequest = exports.proxyApi = exports.deleteRequest = exports.getResponse = exports.createRequest = void 0;
const utils_1 = require("../utils");
const provider_1 = require("../provider");
const methods_1 = require("./methods");
Object.defineProperty(exports, "createRequest", { enumerable: true, get: function () { return methods_1.createRequest; } });
Object.defineProperty(exports, "getResponse", { enumerable: true, get: function () { return methods_1.getResponse; } });
Object.defineProperty(exports, "deleteRequest", { enumerable: true, get: function () { return methods_1.deleteRequest; } });
Object.defineProperty(exports, "proxyApi", { enumerable: true, get: function () { return methods_1.proxyApi; } });
Object.defineProperty(exports, "getRequest", { enumerable: true, get: function () { return methods_1.getRequest; } });
const proxyProvider = (conf) => __awaiter(void 0, void 0, void 0, function* () {
    let { strategy, request, disableCleanupRequest, id, signal } = conf, delegate = __rest(conf, ["strategy", "request", "disableCleanupRequest", "id", "signal"]);
    if (id != null)
        request = yield (0, methods_1.getRequest)(id, signal);
    else
        id = yield (0, methods_1.createRequest)(request, signal);
    return new Promise((resolve, reject) => {
        var _a, _b;
        const socketApi = methods_1.proxyApi.replace("https", "wss");
        let fallbackHttpTimer = null;
        let socket = null;
        const clear = () => __awaiter(void 0, void 0, void 0, function* () {
            fallbackHttpTimer = -1;
            clearInterval(fallbackHttpTimer);
            socket === null || socket === void 0 ? void 0 : socket.close();
            if (disableCleanupRequest !== true) {
                yield (0, methods_1.deleteRequest)(id);
            }
        });
        const processApprove = (data) => {
            var _a, _b, _c, _d, _e, _f;
            switch (data.status) {
                case provider_1.HereProviderStatus.APPROVING:
                    (_a = delegate.onApproving) === null || _a === void 0 ? void 0 : _a.call(delegate, data);
                    (_b = strategy === null || strategy === void 0 ? void 0 : strategy.onApproving) === null || _b === void 0 ? void 0 : _b.call(strategy, data);
                    return;
                case provider_1.HereProviderStatus.FAILED:
                    clear();
                    reject(new provider_1.HereProviderError(data.payload));
                    (_c = delegate.onFailed) === null || _c === void 0 ? void 0 : _c.call(delegate, data);
                    (_d = strategy === null || strategy === void 0 ? void 0 : strategy.onFailed) === null || _d === void 0 ? void 0 : _d.call(strategy, data);
                    return;
                case provider_1.HereProviderStatus.SUCCESS:
                    clear();
                    resolve(data);
                    (_e = delegate.onSuccess) === null || _e === void 0 ? void 0 : _e.call(delegate, data);
                    (_f = strategy === null || strategy === void 0 ? void 0 : strategy.onSuccess) === null || _f === void 0 ? void 0 : _f.call(strategy, data);
                    return;
            }
        };
        const rejectAction = (payload) => {
            processApprove({ status: provider_1.HereProviderStatus.FAILED, payload });
        };
        (_a = delegate.onRequested) === null || _a === void 0 ? void 0 : _a.call(delegate, id, request, rejectAction);
        (_b = strategy === null || strategy === void 0 ? void 0 : strategy.onRequested) === null || _b === void 0 ? void 0 : _b.call(strategy, id, request, rejectAction);
        signal === null || signal === void 0 ? void 0 : signal.addEventListener("abort", () => rejectAction());
        const setupTimer = () => {
            if (fallbackHttpTimer === -1) {
                return;
            }
            fallbackHttpTimer = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b;
                try {
                    const data = yield (0, methods_1.getResponse)(id);
                    if (fallbackHttpTimer === -1)
                        return;
                    processApprove(data);
                    setupTimer();
                }
                catch (e) {
                    const status = provider_1.HereProviderStatus.FAILED;
                    const error = e instanceof Error ? e : undefined;
                    const payload = error === null || error === void 0 ? void 0 : error.message;
                    clear();
                    reject(new provider_1.HereProviderError(payload, error));
                    (_a = delegate.onFailed) === null || _a === void 0 ? void 0 : _a.call(delegate, { status, payload });
                    (_b = strategy === null || strategy === void 0 ? void 0 : strategy.onFailed) === null || _b === void 0 ? void 0 : _b.call(strategy, { status, payload });
                }
            }), 3000);
        };
        setupTimer();
        // Mobile flow doesn't support cross tabs socket background process
        if ((0, utils_1.isMobile)() === false) {
            const endpoint = `${socketApi}/ws/${id}`;
            socket = new WebSocket(endpoint);
            socket.onmessage = (e) => {
                if (e.data == null)
                    return;
                try {
                    const data = JSON.parse(e.data);
                    processApprove(data);
                }
                catch (_a) {
                    // nope
                }
            };
        }
    });
});
exports.proxyProvider = proxyProvider;
//# sourceMappingURL=index.js.map